import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "exam-time"
};
const _hoisted_2 = {
  class: "exam-vocabulary paper-context"
};
const _hoisted_3 = {
  class: "rest"
};
const _hoisted_4 = {
  class: "rest-box"
};
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = {
  style: {
    "width": "100%",
    "overflow-y": "auto"
  }
};
const _hoisted_7 = {
  class: "example"
};
const _hoisted_8 = {
  class: "example-item"
};
const _hoisted_9 = {
  class: "example-content"
};
const _hoisted_10 = {
  class: "example-radio"
};
const _hoisted_11 = {
  class: "example-item"
};
const _hoisted_12 = {
  class: "example-content"
};
const _hoisted_13 = {
  class: "example-radio"
};
const _hoisted_14 = {
  style: {
    "width": "100%",
    "overflow-y": "auto"
  }
};
const _hoisted_15 = {
  class: "example-2"
};
const _hoisted_16 = {
  class: "example-item"
};
const _hoisted_17 = {
  class: "example-content"
};
const _hoisted_18 = {
  class: "example-radio-box"
};
const _hoisted_19 = {
  class: "example-radio"
};
const _hoisted_20 = {
  class: "example-radio"
};
const _hoisted_21 = {
  class: "example-item"
};
const _hoisted_22 = {
  class: "example-content"
};
const _hoisted_23 = {
  class: "example-radio"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_step = _resolveComponent("el-step");
  const _component_el_steps = _resolveComponent("el-steps");
  const _component_el_button = _resolveComponent("el-button");
  const _component_vocabulary_mcq = _resolveComponent("vocabulary_mcq");
  const _component_saq = _resolveComponent("saq");
  const _component_mcq = _resolveComponent("mcq");
  const _component_MenuBox = _resolveComponent("MenuBox");
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_steps, {
    active: $setup.stage,
    simple: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_el_step, {
      title: `词汇 ${$setup.stage == 0 ? $setup.step + 1 : 4}/4（约15min)`,
      icon: $setup.EditPen
    }, null, 8, ["title", "icon"]), _createVNode(_component_el_step, {
      title: `词缀 ${$setup.stage == 1 ? $setup.step + 1 : $setup.stage == 0 ? 0 : 2}/2 (约5min)`,
      icon: $setup.EditPen
    }, null, 8, ["title", "icon"]), _createVNode(_component_el_step, {
      title: `词汇搭配与用法 ${$setup.stage == 2 ? $setup.step + 1 : 0}/2 (约10min,各5min)`,
      icon: $setup.EditPen
    }, null, 8, ["title", "icon"])]),
    _: 1
  }, 8, ["active"]), $setup.paperInfo.items ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("p", null, [_cache[16] || (_cache[16] = _createTextVNode(" 考试时间", -1)), _createElementVNode("span", null, _toDisplayString($setup.timeText), 1)], 512), [[_vShow, $setup.stage == 2]]), _withDirectives(_createVNode(_component_el_button, {
    color: "#1d5595",
    type: "success",
    size: "large",
    onClick: _cache[0] || (_cache[0] = $event => $setup.finishExam(1))
  }, {
    default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("交 卷", -1)]))]),
    _: 1
  }, 512), [[_vShow, $setup.stage == 2 && $setup.step == 1]])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [$setup.stage == 2 && $setup.step == 0 && $setup.reRender ? (_openBlock(), _createBlock(_component_vocabulary_mcq, {
    key: 0,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answer,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : $setup.paperInfo.items[$setup.itemNo] && $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'saq' && $setup.reRender ? (_openBlock(), _createBlock(_component_saq, {
    key: 1,
    onSetAnswer: $setup.setAnswer,
    allAnswers: $setup.cache.answer,
    questionInfo: $setup.paperInfo.items[$setup.itemNo]
  }, null, 8, ["onSetAnswer", "allAnswers", "questionInfo"])) : $setup.reRender && $setup.paperInfo.items[$setup.itemNo] && ($setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'mcq' || $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'mmcq' || $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'judge') ? (_openBlock(), _createBlock(_component_mcq, {
    key: 2,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answer,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : _createCommentVNode("", true)]), $setup.paperInfo.items ? (_openBlock(), _createBlock(_component_MenuBox, {
    key: 1,
    menuRe: $setup.menuRe,
    examType: $props.examInfo.subdivide,
    paperInfo: $setup.paperInfo,
    itemNo: $setup.itemNo,
    answers: $setup.cache.answer,
    isLineType: $setup.stage < 2,
    onChangePaper: _cache[1] || (_cache[1] = $event => $setup.nextItem()),
    onChangeItem: $setup.nextItem
  }, null, 8, ["menuRe", "examType", "paperInfo", "itemNo", "answers", "isLineType", "onChangeItem"])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("p", _hoisted_5, " Section " + _toDisplayString($setup.stageNo[$setup.stage + 1]) + " " + _toDisplayString($setup.stage == 0 ? "词缀测试" : "词汇搭配与用法"), 1), _withDirectives(_createElementVNode("div", _hoisted_6, [_cache[32] || (_cache[32] = _createElementVNode("div", {
    class: "note"
  }, [_createElementVNode("p", null, "注意事项："), _createElementVNode("p", null, " 1.词缀测试为自适应测试，系统会根据你的作答结果推送下一道考试题目，试题作答完后不可返回修改 "), _createElementVNode("p", null, " 2.词缀测试主要考查考生所具备的词汇生成知识。试题分为两个部分，共15小题，包括词缀的意义（meaning）和语法功能（function） ")], -1)), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_cache[24] || (_cache[24] = _createElementVNode("p", null, "词缀意义（meaning）的题目示例：", -1)), _createElementVNode("div", _hoisted_9, [_cache[22] || (_cache[22] = _createElementVNode("span", {
    style: {
      "font-weight": "700"
    }
  }, "Example:", -1)), _cache[23] || (_cache[23] = _createTextVNode(" -ed(walked;played) ", -1)), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_radio, {
    label: "A",
    size: "large",
    modelValue: $setup.exampleAnswer[0],
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.exampleAnswer[0] = $event)
  }, {
    default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode(" A.past ", -1)]))]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_radio, {
    label: "B",
    size: "large",
    modelValue: $setup.exampleAnswer[0],
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $setup.exampleAnswer[0] = $event)
  }, {
    default: _withCtx(() => [...(_cache[19] || (_cache[19] = [_createTextVNode(" B.not ", -1)]))]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_radio, {
    label: "C",
    size: "large",
    modelValue: $setup.exampleAnswer[0],
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $setup.exampleAnswer[0] = $event)
  }, {
    default: _withCtx(() => [...(_cache[20] || (_cache[20] = [_createTextVNode(" C.many ", -1)]))]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_radio, {
    label: "D",
    size: "large",
    modelValue: $setup.exampleAnswer[0],
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $setup.exampleAnswer[0] = $event)
  }, {
    default: _withCtx(() => [...(_cache[21] || (_cache[21] = [_createTextVNode(" D.person ", -1)]))]),
    _: 1
  }, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_11, [_cache[31] || (_cache[31] = _createElementVNode("p", null, "词缀语法功能（function）的题目示例：", -1)), _createElementVNode("div", _hoisted_12, [_cache[29] || (_cache[29] = _createElementVNode("span", {
    style: {
      "font-weight": "700"
    }
  }, "Example:", -1)), _cache[30] || (_cache[30] = _createTextVNode(" -ly(beautifully;nicely) ", -1)), _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_radio, {
    label: "A",
    size: "large",
    modelValue: $setup.exampleAnswer[1],
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $setup.exampleAnswer[1] = $event)
  }, {
    default: _withCtx(() => [...(_cache[25] || (_cache[25] = [_createTextVNode(" A.noun ", -1)]))]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_radio, {
    label: "B",
    size: "large",
    modelValue: $setup.exampleAnswer[1],
    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $setup.exampleAnswer[1] = $event)
  }, {
    default: _withCtx(() => [...(_cache[26] || (_cache[26] = [_createTextVNode(" B.adjective", -1)]))]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_radio, {
    label: "C",
    size: "large",
    modelValue: $setup.exampleAnswer[1],
    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $setup.exampleAnswer[1] = $event)
  }, {
    default: _withCtx(() => [...(_cache[27] || (_cache[27] = [_createTextVNode(" C.verb ", -1)]))]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_radio, {
    label: "D",
    size: "large",
    modelValue: $setup.exampleAnswer[1],
    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $setup.exampleAnswer[1] = $event)
  }, {
    default: _withCtx(() => [...(_cache[28] || (_cache[28] = [_createTextVNode(" D.adverb ", -1)]))]),
    _: 1
  }, 8, ["modelValue"])])])])])], 512), [[_vShow, $setup.stage == 0]]), _withDirectives(_createElementVNode("div", _hoisted_14, [_cache[52] || (_cache[52] = _createElementVNode("div", {
    class: "note"
  }, [_createElementVNode("p", null, "注意事项："), _createElementVNode("p", null, [_createTextVNode(" 1.词汇搭配与用法测试包含两部分："), _createElementVNode("br"), _createTextVNode(" 第一部分：词汇联想、搭配，主要考察考生构建词汇网络与语义网络的能力，共是10题，作答时间5分钟。"), _createElementVNode("br"), _createTextVNode(" 第二部分：习语，主要考察考生对英语中最常见的习语的了解程度。共10题，作答时间5分钟。 ")]), _createElementVNode("p", null, " 2.词汇搭配与用法测试的试题可以返回修改，也可以根据题号选择作答或修改。 ")], -1)), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_cache[45] || (_cache[45] = _createElementVNode("p", {
    class: "example-item-title"
  }, "词汇联想、搭配的题目示例：", -1)), _createElementVNode("div", _hoisted_17, [_cache[43] || (_cache[43] = _createElementVNode("p", {
    style: {
      "font-weight": "700",
      "width": "100%"
    }
  }, "Example:", -1)), _cache[44] || (_cache[44] = _createElementVNode("p", {
    class: "example-title"
  }, "far", -1)), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_cache[37] || (_cache[37] = _createElementVNode("p", null, "与far含义相关的有：", -1)), _createVNode(_component_el_checkbox_group, {
    max: 2,
    modelValue: $setup.exampleAnswer[2],
    "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $setup.exampleAnswer[2] = $event)
  }, {
    default: _withCtx(() => [_createVNode(_component_el_checkbox, {
      label: "A",
      size: "large"
    }, {
      default: _withCtx(() => [...(_cache[33] || (_cache[33] = [_createTextVNode("A.near ", -1)]))]),
      _: 1
    }), _createVNode(_component_el_checkbox, {
      label: "B",
      size: "large"
    }, {
      default: _withCtx(() => [...(_cache[34] || (_cache[34] = [_createTextVNode("B.much ", -1)]))]),
      _: 1
    }), _createVNode(_component_el_checkbox, {
      label: "C",
      size: "large"
    }, {
      default: _withCtx(() => [...(_cache[35] || (_cache[35] = [_createTextVNode("C.distant ", -1)]))]),
      _: 1
    }), _createVNode(_component_el_checkbox, {
      label: "D",
      size: "large"
    }, {
      default: _withCtx(() => [...(_cache[36] || (_cache[36] = [_createTextVNode("D.distant", -1)]))]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_20, [_cache[42] || (_cache[42] = _createElementVNode("p", null, "与far可组成固定搭配的有：", -1)), _createVNode(_component_el_checkbox_group, {
    max: 2,
    modelValue: $setup.exampleAnswer[3],
    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $setup.exampleAnswer[3] = $event)
  }, {
    default: _withCtx(() => [_createVNode(_component_el_checkbox, {
      label: "A",
      size: "large"
    }, {
      default: _withCtx(() => [...(_cache[38] || (_cache[38] = [_createTextVNode("A.likely ", -1)]))]),
      _: 1
    }), _createVNode(_component_el_checkbox, {
      label: "B",
      size: "large"
    }, {
      default: _withCtx(() => [...(_cache[39] || (_cache[39] = [_createTextVNode("B.extremely ", -1)]))]),
      _: 1
    }), _createVNode(_component_el_checkbox, {
      label: "C",
      size: "large"
    }, {
      default: _withCtx(() => [...(_cache[40] || (_cache[40] = [_createTextVNode("C.really ", -1)]))]),
      _: 1
    }), _createVNode(_component_el_checkbox, {
      label: "D",
      size: "large"
    }, {
      default: _withCtx(() => [...(_cache[41] || (_cache[41] = [_createTextVNode("D.hardly", -1)]))]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue"])])])])]), _createElementVNode("div", _hoisted_21, [_cache[51] || (_cache[51] = _createElementVNode("p", {
    class: "example-item-title"
  }, "习语的题目示例：", -1)), _createElementVNode("div", _hoisted_22, [_cache[50] || (_cache[50] = _createElementVNode("p", {
    style: {
      "width": "100%"
    }
  }, [_createElementVNode("span", {
    style: {
      "font-weight": "700"
    }
  }, "Example:"), _createTextVNode(" Franklin' s illness was ______, for it gave him a chance which he had not had before. ")], -1)), _createElementVNode("div", _hoisted_23, [_createVNode(_component_el_radio, {
    label: "A",
    size: "large",
    modelValue: $setup.exampleAnswer[4],
    "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $setup.exampleAnswer[4] = $event)
  }, {
    default: _withCtx(() => [...(_cache[46] || (_cache[46] = [_createTextVNode(" A. the upper hand ", -1)]))]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_radio, {
    label: "B",
    size: "large",
    modelValue: $setup.exampleAnswer[4],
    "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $setup.exampleAnswer[4] = $event)
  }, {
    default: _withCtx(() => [...(_cache[47] || (_cache[47] = [_createTextVNode(" B.out of the blocks", -1)]))]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_radio, {
    label: "C",
    size: "large",
    modelValue: $setup.exampleAnswer[4],
    "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $setup.exampleAnswer[4] = $event)
  }, {
    default: _withCtx(() => [...(_cache[48] || (_cache[48] = [_createTextVNode(" C. the luck of the draw ", -1)]))]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_radio, {
    label: "D",
    size: "large",
    modelValue: $setup.exampleAnswer[4],
    "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $setup.exampleAnswer[4] = $event)
  }, {
    default: _withCtx(() => [...(_cache[49] || (_cache[49] = [_createTextVNode(" D.a blessing in disguise ", -1)]))]),
    _: 1
  }, 8, ["modelValue"])])])])])], 512), [[_vShow, $setup.stage == 1]]), _createVNode(_component_el_button, {
    size: "large",
    type: "primary",
    plain: "",
    onClick: $setup.nextStage
  }, {
    default: _withCtx(() => [...(_cache[53] || (_cache[53] = [_createTextVNode("准备好了，开始测试", -1)]))]),
    _: 1
  }, 8, ["onClick"])])], 512), [[_vShow, $setup.stageChangeFlag]])], 64);
}